import toast from "react-hot-toast";
import * as api from "../Api";
import { allApprovedInsurance } from "./approvedInsurance";

const errorText = (error) =>
  error?.response?.data?.message || error?.message || "Something went wrong";

export const getAllUnapprovedInsurance = () => async (dispatch) => {
  try {
    const { data } = await api.newInsurance();
    dispatch({ type: "GET_ALL_UNAPPROVED_INSURANCE", payload: data });
  } catch (error) {
    dispatch({ type: "LOAD_FAILED", failed: "GET_ALL_UNAPPROVED_INSURANCE" });
  }
};

export const approveInsurance = (id, postData) => async (dispatch) => {
  const approvingId = toast.loading("Approving...");
  try {
    await api.approveInsurance(id, postData);
    dispatch({ type: "APPROVE_NEW_INSURANCE", payload: id });
    // The dashboard and report read the approved list
    dispatch(allApprovedInsurance());
    toast.success("Insurance approved", { id: approvingId });
  } catch (error) {
    toast.error(errorText(error), { id: approvingId });
  }
};

export const deleteUnapprovedInsurance = (id) => async (dispatch) => {
  const deletingId = toast.loading("Deleting...");
  try {
    await api.deleteInsurance(id);
    dispatch({ type: "DELETE_NEW_INSURANCE", payload: id });
    toast.success("Insurance deleted", { id: deletingId });
  } catch (error) {
    toast.error(errorText(error), { id: deletingId });
  }
};
